export default __webpack_public_path__ + "static/media/tresguerras-logo.7781f590.png";